const isHome = (ctx) => !ctx?.m || ctx?.m === 'home';

export {isHome};
